import { createFileRoute } from '@tanstack/react-router'
import { MainPreferences } from '@admin/preferences/MainPreferences'

export const Route = createFileRoute('/_auth/preferences')({
  component: RouteComponent,
})

function RouteComponent() {
  return <MainPreferences />
}
